import { create } from 'zustand';

function getListMode() {

    try {

        const saved = localStorage.getItem('listMode');
        return saved ?? 'cards';
        
    } catch {
        return 'cards';
    }
    
}

function saveListMode(listMode) {

    try {

        localStorage.setItem('listMode', listMode);
        
    } catch {}

}

const initialListMode = getListMode();

export const useListModeStore = create((set, get) => ({

    listMode: initialListMode,

    toggleListMode: () => {

        const listMode =
            get().listMode === 'cards'
                ? 'list'
                : 'cards';

        set({ listMode });

        saveListMode(listMode);

    }

}));